import { defineStyle, defineStyleConfig } from "@chakra-ui/react";

const brand = defineStyle({ color: "brand.500" });
const gray = defineStyle({ color: "gray.600" });
const green = defineStyle({ color: "green.500" });
const white = defineStyle({ color: "white" });
const red = defineStyle({ color: "red.500" });
const purple = defineStyle({ color: "purple.500" });
const black = defineStyle({ color: "#000000" });

export const Text = defineStyleConfig({
  variants: {
    brand,
    gray,
    green,
    white,
    red,
    purple,
    black,
  },

  defaultProps: {
    variant: "gray",
  },
});
